import React, { useEffect, useState } from "react";
import InterfaceComponent from "../Masters/InterfaceComponent";
import { ActionHandlerProvider } from "../../Components/ActionHandlerContext";
import { useRef } from "react";
import { FormInstance, message } from "antd";
import { API } from "../../Axios/Axios";
import {
  AcknowledgeRequest,
  getRequestDetailsById,
  getTargetClosureDateByPriority,
  getUserDeptAndUnit,
  InitiateRequestWorkflow,
  RequestClosure,
  getProductCodeByProduct,
} from "../../Helpers/APIEndpoints/Endpoints";
import { useAuthStore } from "../../AuthStore/AuthStore";
import { RequestStatusEnum } from "../../Enum/RequestStatusEnum";
import dayjs from "dayjs";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { RoleEnum } from "../../Enum/RoleEnum";
import { DecisionEnum } from "../../Enum/DecisionEnum";
import { ApiStatus } from "../../Enum/ApiStatusEnum";

const RequestDetailInterface = () => {
  const formRef = useRef<FormInstance>(null);
  const { commonContextParams } = useAuthStore();
  const location = useLocation();
  const [readOnlyTabs, setReadOnlyTabs] = useState<string[]>([]);
  const navigate = useNavigate();
  const hasRedirected = useRef(false);
  //Email Redirection handling from request dashboard to request details tab handling
  const [searchParams] = useSearchParams();
  const queryRId = searchParams.get("RId");

  useEffect(() => {
    if (queryRId) {
      navigate(location.pathname, {
        replace: true,
        state: {
          actionType: "Edit",
          RId: Number(queryRId),
          Mode: "Edit",
        },
      });
    }
  }, []);

  //---------------------------------------------------------------------

  const requestStatusIdRef = useRef<number>(0);

  const RequestDetailTabFields = [
    {
      fieldName: "Initiator",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "InitiatorDepartment",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "InitiatorUnit",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RequestDate",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Channel",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RequestDescription",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RequestType",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "OtherRequestType",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "BusinessChannel",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "BusinessImpact",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ExpectedRevenue",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "InternalExternal",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "CustomerName",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ContactPerson",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ContactNumber",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "EmailAddress",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "CustomerAccountNumber",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "CountryLocation",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Location",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ProductType",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Product",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ProductDescription",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "SupportingDocuments",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RequestCategory",
      updates: { isFieldDisable: true },
    },
    // {
    //   fieldName: "SupportingDocuments",
    //   updates: { isFieldDisable: true },
    // },
  ];
  const AcknowledgementDetailsTabFields = [
    {
      fieldName: "DecisionRDHead",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RemarksRDHead",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Priority",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ObservationCategory",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "EstimatedResources",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Impact",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "AssignTo",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "TargetClosureDate",
      updates: { isFieldDisable: true },
    },
  ];
  const ClosureDetailsTabFields = [
    {
      fieldName: "HoursSpentforClosure",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Outcome",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "CostSaved",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "TimeUtilized",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ClosureRemarks",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ClosureDetailsSupportingDocuments",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RnDHeadClosureDecisionId",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RnDHeadClosureRemarks",
      updates: { isFieldDisable: true },
    },
  ];

  const tabFieldConfig: Record<string, any[]> = {
    "Request Details": RequestDetailTabFields,
    "Acknowledgement Details": AcknowledgementDetailsTabFields,
    // "Task Details": TaskDetailsTabFields,
    "Closure Details": ClosureDetailsTabFields,
  };

  const handleFieldVisibility = (
    tabNames: string | string[],
    disableFlag: boolean,
  ): Array<{ fieldName: string; updates: any }> => {
    const tabsArray = Array.isArray(tabNames) ? tabNames : [tabNames];

    return tabsArray.flatMap((tabName) => {
      const fields = tabFieldConfig[tabName];
      if (!fields) return [];

      return fields.map((field) => ({
        ...field,
        updates: {
          ...field.updates,
          isFieldDisable: disableFlag,
        },
      }));
    });
  };

  const disableTabs = (tabNames: string[]) => {
    formRef.current?.disableTabs(tabNames);
  };

  const enableTabs = (tabNames: string[]) => {
    formRef.current?.enableTabs(tabNames);
  };

  const presetValues = (values: Record<string, any>) => {
    Object.entries(values).forEach(([key, val]) => {
      formRef.current?.setValue(key, val);
    });
  };

  const hideFields = (fieldNames: string[]) => {
    fieldNames.forEach((name, i) => {
      setTimeout(() => formRef.current?.hideFields(name), i * 0);
    });
  };

  const showFields = (fieldNames: string[]) => {
    fieldNames.forEach((name, i) => {
      setTimeout(() => formRef.current?.showFields(name), i * 0);
    });
  };

  const enableFields = (fieldNames: string[]) => {
    fieldNames.forEach((name, i) => {
      setTimeout(() => formRef.current?.enableField(name), i * 0);
    });
  };

  const disableFields = (fieldNames: string[]) => {
    fieldNames.forEach((name, i) => {
      setTimeout(() => formRef.current?.disableField(name), i * 0);
    });
  };

  const handleCancel1 = () => {
    // Navigate back to the previous page
    window.history.back();
  };

  const interfaceActionHandler = {
    customJsonMethod: async (apiValues: any, fieldName: any) => {
      console.log("customJsonMethod called");
      let value = {
        testMarks: 32358,
      };

      return value;
    },
    PrevTab: () => {
      formRef.current?.setPrevTabAsActive();
    },
    NextTab: () => {
      formRef.current?.setNextTabAsActive1();
    },
    SetActiveTab: (tabName: string) => {
      formRef?.current?.setActiveTabByName(tabName);
    },
    SetFieldVisibility: (updates: { fieldName: string; updates: any }[]) => {
      formRef.current?.setFieldVisibility(updates);
    },
    EnableTabs: (tabNames: string[]) => {
      formRef.current?.enableTabs(tabNames);
    },
    DisableTabs: (tabNames: string[]) => {
      formRef.current?.disableTabs(tabNames);
    },
    UpdateRequestStatusId: (statusId: number) => {
      requestStatusIdRef.current = statusId;
    },
    handleFormReady: async (form: any, RId: any) => {
      if (!formRef.current) return;

      console.log(
        "OnLoad Triggered Cleanly11",
        form,
        "RID: ",
        RId,
        "location",
        location?.state,
      );

      await formRef.current?.setFieldVisibility([
        {
          fieldName: "OtherRequestType",
          updates: { isFieldVisible: false },
        },
        // {
        //   fieldName: ">",
        //   updates: { isFieldDisable: true }
        // },
      ]);

      //Acknowledgement Details Tab - Decision change field visibility and mandatory rule handling
      if (Number(form?.DecisionRDHead) == DecisionEnum.AssignRnDManager) {
        console.log("Showing Field on decision change");

        formRef.current?.setFieldVisibility([
          {
            fieldName: "Priority",
            updates: { isFieldVisible: true },
          },
          {
            fieldName: "ObservationCategory",
            updates: { isFieldVisible: true },
          },
          {
            fieldName: "EstimatedResources",
            updates: { isFieldVisible: true },
          },
          {
            fieldName: "Impact",
            updates: { isFieldVisible: true },
          },
          {
            fieldName: "AssignTo",
            updates: { isFieldVisible: true },
          },
          {
            fieldName: "TargetClosureDate",
            updates: { isFieldVisible: true },
          },
        ]);

        formRef.current?.UpdateFieldMandatoryRule("Priority", true);
        formRef.current?.UpdateFieldMandatoryRule("ObservationCategory", true);
        formRef.current?.UpdateFieldMandatoryRule("EstimatedResources", true);
        formRef.current?.UpdateFieldMandatoryRule("Impact", true);
        formRef.current?.UpdateFieldMandatoryRule("AssignTo", true);
        formRef.current?.UpdateFieldMandatoryRule("TargetClosureDate", true);
      } else {
        formRef.current?.setFieldVisibility([
          {
            fieldName: "Priority",
            updates: { isFieldVisible: false },
          },
          {
            fieldName: "ObservationCategory",
            updates: { isFieldVisible: false },
          },
          {
            fieldName: "EstimatedResources",
            updates: { isFieldVisible: false },
          },
          {
            fieldName: "Impact",
            updates: { isFieldVisible: false },
          },
          {
            fieldName: "AssignTo",
            updates: { isFieldVisible: false },
          },
          {
            fieldName: "TargetClosureDate",
            updates: { isFieldVisible: false },
          },
        ]);
        formRef.current?.UpdateFieldMandatoryRule("Priority", false);
        formRef.current?.UpdateFieldMandatoryRule("ObservationCategory", false);
        formRef.current?.UpdateFieldMandatoryRule("EstimatedResources", false);
        formRef.current?.UpdateFieldMandatoryRule("Impact", false);
        formRef.current?.UpdateFieldMandatoryRule("AssignTo", false);
        formRef.current?.UpdateFieldMandatoryRule("TargetClosureDate", false);
      }

      //Redirection from task dashboard to task details tab handling
      if (
        !hasRedirected.current &&
        location?.state?.TaskDetailId &&
        location?.state?.TaskDetailId > 0
      ) {
        formRef?.current?.setActiveTabByName("Task Details");

        hasRedirected.current = true; // ✅ prevent re-run
      }

      //Custom handling of tab visibility and field visibility based on request status and user role

      const res = await API.post(getRequestDetailsById, { RequestId: RId });
      console.log("Request details by id response", res);
      if (res?.data?.data?.length > 0) {
        requestStatusIdRef.current = res?.data?.data[0]?.requestStatusId;
      }

      if (
        (requestStatusIdRef.current == RequestStatusEnum.RequestInDraft ||
          requestStatusIdRef.current == RequestStatusEnum.ReopenedByRnDHead ||
          requestStatusIdRef.current == 0) &&
        RoleEnum.Initiator == commonContextParams?.roleId
      ) {
        console.log("Request in Draft - Showing save/submit button");
        if (requestStatusIdRef.current == RequestStatusEnum.ReopenedByRnDHead) {
          formRef.current?.setFieldVisibility([
            {
              fieldName: "RequestDetailSave",
              updates: { isFieldDisable: true },
            },
            {
              fieldName: "RequestDetailSubmit",
              updates: { isFieldDisable: false },
            },
          ]);
        } else {
          formRef.current?.setFieldVisibility([
            {
              fieldName: "RequestDetailSave",
              updates: { isFieldDisable: false },
            },
            {
              fieldName: "RequestDetailSubmit",
              updates: { isFieldDisable: false },
            },
          ]);
        }
      } else {
        console.log("Request not in draft - Hiding save/submit button");
        formRef.current?.setFieldVisibility([
          {
            fieldName: "RequestDetailSave",
            updates: { isFieldDisable: true },
          },
          {
            fieldName: "RequestDetailSubmit",
            updates: { isFieldDisable: true },
          },
        ]);
      }

      if (
        requestStatusIdRef.current ==
          RequestStatusEnum.PendingForAcknowledgement &&
        RoleEnum.Initiator == commonContextParams?.roleId
      ) {
        formRef.current?.setFieldVisibility([
          {
            fieldName: "RequestDetailRecall",
            updates: { isFieldDisable: false },
          },
          {
            fieldName: "RecallRemarks",
            updates: { isFieldVisible: true },
          },
        ]);
      } else {
        formRef.current?.setFieldVisibility([
          {
            fieldName: "RequestDetailRecall",
            updates: { isFieldDisable: true },
          },
          {
            fieldName: "RecallRemarks",
            updates: { isFieldVisible: false },
          },
        ]);
      }

      if (
        requestStatusIdRef.current == RequestStatusEnum.RequestInDraft ||
        requestStatusIdRef.current == 0
      ) {
        console.log("Request in Draft - 1");
        enableTabs(["Request Details"]);
        disableTabs([
          "Acknowledgement Details",
          "Task Details",
          "Closure Details",
        ]);

        if (
          Number(commonContextParams?.roleId) !== Number(RoleEnum.Initiator)
        ) {
          formRef.current?.setFieldVisibility(
            handleFieldVisibility("Request Details", true),
          );
        }
        // setReadOnlyTabs([]);
      } else if (
        requestStatusIdRef.current ==
          RequestStatusEnum.PendingForAcknowledgement ||
        requestStatusIdRef.current == RequestStatusEnum.ReopenedByRnDHead ||
        requestStatusIdRef.current == RequestStatusEnum.RequestAssignmentPending
      ) {
        console.log("Request pending for acknowledgement 2");

        enableTabs(["Request Details", "Acknowledgement Details"]);
        disableTabs(["Task Details", "Closure Details"]);
        if (
          requestStatusIdRef.current ==
            RequestStatusEnum.PendingForAcknowledgement ||
          requestStatusIdRef.current ==
            RequestStatusEnum.RequestAssignmentPending
        ) {
          let arr = handleFieldVisibility("Request Details", true);
          formRef.current?.setFieldVisibility(arr);
        }
        if (
          requestStatusIdRef.current == RequestStatusEnum.ReopenedByRnDHead &&
          Number(commonContextParams?.roleId) == Number(RoleEnum.Initiator)
        ) {
          let arr = handleFieldVisibility("Request Details", false);
          formRef.current?.setFieldVisibility(arr);
          formRef.current?.setFieldVisibility([
            {
              fieldName: "Initiator",
              updates: { isFieldDisable: true },
            },
            {
              fieldName: "InitiatorDepartment",
              updates: { isFieldDisable: true },
            },
            {
              fieldName: "InitiatorUnit",
              updates: { isFieldDisable: true },
            },
          ]);
        } else {
          let arr = handleFieldVisibility("Request Details", true);
          formRef.current?.setFieldVisibility(arr);
        }

        if (
          Number(commonContextParams?.roleId) !== Number(RoleEnum.RnDHead) ||
          requestStatusIdRef.current == RequestStatusEnum.ReopenedByRnDHead
        ) {
          formRef.current?.setFieldVisibility(
            handleFieldVisibility("Acknowledgement Details", true),
          );

          formRef.current?.setFieldVisibility([
            {
              fieldName: "AcknowledgementSubmit",
              updates: { isFieldDisable: true },
            },
          ]);
        }
      } else if (
        requestStatusIdRef.current == RequestStatusEnum.TaskAssignmentPending ||
        requestStatusIdRef.current == RequestStatusEnum.TasksWIPWithTaskOwner
      ) {
        console.log("Request pending for task assignment - 3");
        enableTabs([
          "Request Details",
          "Acknowledgement Details",
          "Task Details",
        ]);
        disableTabs(["Closure Details"]);

        formRef.current?.setFieldVisibility([
          ...handleFieldVisibility("Request Details", true),
          ...handleFieldVisibility("Acknowledgement Details", true),
        ]);

        formRef.current?.setFieldVisibility([
          {
            fieldName: "AcknowledgementSubmit",
            updates: { isFieldDisable: true },
          },
        ]);
      } else if (
        requestStatusIdRef.current ==
          RequestStatusEnum.PendingForRequestClosureRnDHead ||
        requestStatusIdRef.current ==
          RequestStatusEnum.PendingForRequestClosureRnDManager ||
        requestStatusIdRef.current == RequestStatusEnum.SendbackByRnDHead
      ) {
        console.log("Tasks WIP with task owner - 4");
        enableTabs([
          "Request Details",
          "Acknowledgement Details",
          "Task Details",
          "Closure Details",
        ]);
        if (
          commonContextParams?.roleId == RoleEnum.Admin ||
          commonContextParams?.roleId == RoleEnum.Initiator ||
          commonContextParams?.roleId == RoleEnum.TaskOwner ||
          commonContextParams?.roleId == RoleEnum.QualityAssurance
        ) {
          console.log("ROle IS ", commonContextParams?.roleId);
          formRef.current?.setFieldVisibility([
            ...handleFieldVisibility("Request Details", true),
            ...handleFieldVisibility("Acknowledgement Details", true),
            ...handleFieldVisibility("Closure Details", true),
          ]);

          formRef.current?.setFieldVisibility([
            {
              fieldName: "AcknowledgementSubmit",
              updates: { isFieldDisable: true },
            },
            {
              fieldName: "ClosureSubmit",
              updates: { isFieldDisable: true },
            },
          ]);
        } else if (
          commonContextParams?.roleId == RoleEnum.RnDManager ||
          commonContextParams?.roleId == RoleEnum.RnDHead
        ) {
          formRef.current?.setFieldVisibility([
            ...handleFieldVisibility("Request Details", true),
            ...handleFieldVisibility("Acknowledgement Details", true),
          ]);

          formRef.current?.setFieldVisibility([
            {
              fieldName: "AcknowledgementSubmit",
              updates: { isFieldDisable: true },
            },
          ]);

          if (
            commonContextParams?.roleId == RoleEnum.RnDManager &&
            (requestStatusIdRef.current ==
              RequestStatusEnum.PendingForRequestClosureRnDManager ||
              requestStatusIdRef.current == RequestStatusEnum.SendbackByRnDHead)
          ) {
            formRef.current?.setFieldVisibility([
              {
                fieldName: "RnDHeadClosureDecisionId",
                updates: { isFieldVisible: false },
              },
              {
                fieldName: "RnDHeadClosureRemarks",
                updates: { isFieldVisible: false },
              },
            ]);
            formRef.current?.UpdateFieldMandatoryRule(
              "RnDHeadClosureDecisionId",
              false,
            );
            formRef.current?.UpdateFieldMandatoryRule(
              "RnDHeadClosureRemarks",
              false,
            );
          } else if (
            commonContextParams?.roleId == RoleEnum.RnDHead &&
            requestStatusIdRef.current ==
              RequestStatusEnum.PendingForRequestClosureRnDManager
          ) {
            console.log("form data 649=>", form);

            formRef.current?.setFieldVisibility([
              {
                fieldName: "ClosureRemarks",
                updates: { isFieldVisible: false },
              },
              {
                fieldName: "RnDHeadClosureDecisionId",
                updates: { fieldOptions: [{ label: "Closed", value: "4" }] },
              },
            ]);
            formRef.current?.UpdateFieldMandatoryRule("ClosureRemarks", false);
          } else if (
            commonContextParams?.roleId == RoleEnum.RnDHead &&
            requestStatusIdRef.current == RequestStatusEnum.SendbackByRnDHead
          ) {
            formRef.current?.setFieldVisibility([
              {
                fieldName: "HoursSpentforClosure",
                updates: { isFieldDisable: true },
              },
              {
                fieldName: "Outcome",
                updates: { isFieldDisable: true },
              },
              {
                fieldName: "CostSaved",
                updates: { isFieldDisable: true },
              },
              {
                fieldName: "TimeUtilized",
                updates: { isFieldDisable: true },
              },
              {
                fieldName: "ClosureRemarks",
                updates: { isFieldDisable: true },
              },
              {
                fieldName: "ClosureSubmit",
                updates: { isFieldDisable: true },
              },
              {
                fieldName: "RnDHeadClosureDecisionId",
                updates: { isFieldDisable: true },
              },
              {
                fieldName: "RnDHeadClosureRemarks",
                updates: { isFieldDisable: true },
              },
            ]);
            formRef.current?.UpdateFieldMandatoryRule("ClosureRemarks", false);
          } else if (
            requestStatusIdRef.current ==
              RequestStatusEnum.PendingForRequestClosureRnDHead &&
            RoleEnum.RnDHead == commonContextParams?.roleId
          ) {
            formRef.current?.setFieldVisibility([
              {
                fieldName: "HoursSpentforClosure",
                updates: { isFieldDisable: true },
              },
              {
                fieldName: "Outcome",
                updates: { isFieldDisable: true },
              },
              {
                fieldName: "CostSaved",
                updates: { isFieldDisable: true },
              },
              {
                fieldName: "TimeUtilized",
                updates: { isFieldDisable: true },
              },
              {
                fieldName: "ClosureRemarks",
                updates: { isFieldDisable: true },
              },
              {
                fieldName: "ClosureDetailsSupportingDocuments",
                updates: { isFieldDisable: true },
              },
            ]);
          } else if (
            RoleEnum.RnDManager == commonContextParams?.roleId &&
            requestStatusIdRef.current ==
              RequestStatusEnum.PendingForRequestClosureRnDHead
          ) {
            formRef.current?.setFieldVisibility([
              {
                fieldName: "ClosureSubmit",
                updates: { isFieldDisable: true },
              },
            ]);
          }
        }
        // formRef.current?.setReadOnlyTabs([
        //   "Request Details",
        //   "Acknowledgement Details",
        //   "Task Details",
        // ]);
      } else if (
        requestStatusIdRef.current == RequestStatusEnum.RequestClosed
      ) {
        enableTabs([
          "Request Details",
          "Acknowledgement Details",
          "Task Details",
          "Closure Details",
        ]);
        formRef.current?.setFieldVisibility([
          ...handleFieldVisibility("Request Details", true),
          ...handleFieldVisibility("Acknowledgement Details", true),
          ...handleFieldVisibility("Closure Details", true),
        ]);

        formRef.current?.setFieldVisibility([
          {
            fieldName: "AcknowledgementSubmit",
            updates: { isFieldDisable: true },
          },
          {
            fieldName: "ClosureSubmit",
            updates: { isFieldDisable: true },
          },
        ]);
      }

      if (RId == 0) {
        console.log("New Request - Fetching user department and unit data");
        try {
          let obj = {
            Id: commonContextParams?.userId,
          };
          const res = await API.post(getUserDeptAndUnit, obj);
          console.log("User Dept and Unit Data:", res);
          if (res?.data?.message === "OK") {
            presetValues({
              Initiator: res?.data?.data?.userName ?? "",
              InitiatorDepartment: `${res?.data?.data?.departmentId ?? ""}`,
              InitiatorUnit: `${res?.data?.data?.unitId ?? ""}`,
            });
            let InitiatorDepartmentFlag = false;

            if (!res?.data?.data?.departmentId) {
              console.log("Enabling Department Field");
              InitiatorDepartmentFlag = false;
              //enableFields(["InitiatorDepartment"]);
            } else {
              console.log("Disabling Department Field");
              InitiatorDepartmentFlag = true;
              //disableFields(["InitiatorDepartment"]);
            }

            let InitiatorUnitFlag = false;
            if (!res?.data?.data?.unitId) {
              //enableFields(["InitiatorUnit"]);
              InitiatorUnitFlag = false;
            } else {
              //disableFields(["InitiatorUnit"]);
              InitiatorUnitFlag = true;
            }

            formRef.current?.setFieldVisibility([
              {
                fieldName: "InitiatorUnit",
                updates: { isFieldDisable: InitiatorUnitFlag },
              },
              {
                fieldName: "InitiatorDepartment",
                updates: { isFieldDisable: InitiatorDepartmentFlag },
              },
            ]);
          }
          // setUserData(res.data);
        } catch (error) {
          console.log("Error fetching user department and unit data:", error);
        }
      } else {
        console.log("Existing Request - Hiding department and unit fields");

        formRef.current?.setFieldVisibility([
          {
            fieldName: "InitiatorUnit",
            updates: { isFieldDisable: true },
          },
          {
            fieldName: "InitiatorDepartment",
            updates: { isFieldDisable: true },
          },
        ]);
      }
    },
    ProcessAcknowledgementTab: async (
      action: any,
      formValue: any,
      button: any,
      interfaceId: any,
    ) => {
      try {
        const payload = {
          rId: formValue.RId ? formValue.RId : null,
          id: formValue.RId ? formValue.RId : null,
          decisionRDHead: formValue.DecisionRDHead
            ? formValue.DecisionRDHead
            : null,
          remarksRDHead: formValue.RemarksRDHead
            ? formValue.RemarksRDHead
            : null,
          priority: formValue.Priority ? formValue.Priority : null,
          observationCategory: formValue.ObservationCategory
            ? formValue.ObservationCategory
            : null,
          impact: formValue.Impact ? formValue.Impact : null,
          assignTo: formValue.AssignTo ? formValue.AssignTo : null,
          targetClosureDate: formValue.TargetClosureDate
            ? new Date(formValue.TargetClosureDate).toISOString()
            : null,
          createdBy: formValue.userId ? formValue.userId : null,
          roleId: formValue.roleId ? formValue.roleId : null,
          EstimatedResources: formValue.EstimatedResources
            ? formValue.EstimatedResources
            : null,
        };

        const updateResponse = await API.post(AcknowledgeRequest, payload);

        console.log("response from API", updateResponse);

        if (
          updateResponse?.data?.message === "OK" &&
          updateResponse?.data?.status === ApiStatus.Success
        ) {
          message.success("Updated successfully.");
          //navigate(-1);
          if (
            Number(commonContextParams?.roleId) === Number(RoleEnum.TaskOwner)
          ) {
            navigate("/TaskDashboard");
          } else {
            navigate("/RequestDashboard");
          }

          return updateResponse;
        } else {
          message.error(
            updateResponse?.data?.errorCode === "DBVALIDATION"
              ? updateResponse.data.message
              : updateResponse?.data?.message || "Failed.",
          );
          return null;
        }
      } catch (error: any) {
        message.error("Something went wrong. Please try again.");
        return null;
      }
    },
    ProcessRequestDetailTab: async (
      action: any,
      formValue: any,
      button: any,
      interfaceId: any,
    ) => {
      try {
        const formData = new FormData();

        console.log("Form Value in ProcessRequestDetailTab:", formValue);

        Object.entries(formValue).forEach(([key, value]: any) => {
          if (!Array.isArray(value)) {
            if (value && value.$d instanceof Date) {
              formData.append(key, value.toISOString());
            } else if (value !== undefined && value !== null) {
              formData.append(key, value);
            }
          }
        });
        if (formValue.rId != null)
          formData.append("RId", formValue.rId.toString());

        if (formValue.rId != null)
          formData.append("Id", formValue.rId.toString());

        if (formValue.userId != null)
          formData.append("CreatedBy", formValue.userId.toString());

        if (formValue.roleId != null)
          formData.append("RoleId", formValue.roleId.toString());

        if (action.actionKey == "DynamicFormActionSave")
          formData.append("IsDraftRequest", "true");
        if (action.actionKey == "DynamicFormActionRecall")
          formData.append("IsRecallRequest", "true");

        console.log("Form Data for ProcessRequestDetailTab:", formData);

        //Attachment Processing
        const fileFieldKeys = Object.keys(formValue).filter(
          (key) =>
            Array.isArray(formValue[key]) &&
            formValue[key].some(
              (item: any) => item?.originFileObj || item?.url || item?.path,
            ),
        );

        const attachmentMap: any = {};

        fileFieldKeys.forEach((fieldKey) => {
          const files = formValue[fieldKey] ?? [];

          const oldAttachments: any[] = [];

          files.forEach((file: any) => {
            if (file.originFileObj) {
              // 🟢 New file
              // formData.append(fieldKey, file.originFileObj);
              formData.append("NewAttachments", file.originFileObj);
            } else {
              // 🔵 Old file
              oldAttachments.push({
                id: file.id ?? "",
                name: file.name ?? "",
                path: file.path ?? file.url ?? "",
              });
            }
          });

          //attachmentMap[fieldKey] = oldAttachments;
          formData.append("AttachmentJson", JSON.stringify(oldAttachments));
        });

        console.log(
          "Form Data with attachments for ProcessRequestDetailTab:",
          formData,
        );

        formData.append("StatusId", requestStatusIdRef.current.toString());
        console.log("StatusId:", requestStatusIdRef.current);

        const response = await API.post(InitiateRequestWorkflow, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        console.log("response from API:", response);

        if (
          response?.data?.message === "OK" &&
          response?.data?.status === ApiStatus.Success
        ) {
          message.success("Saved successfully.");
          //navigate(-1);
          if (
            Number(commonContextParams?.roleId) === Number(RoleEnum.TaskOwner)
          ) {
            navigate("/TaskDashboard");
          } else {
            navigate("/RequestDashboard");
          }
          return response;
        } else {
          message.error(
            response?.data?.errorCode === "DBVALIDATION"
              ? response.data.message
              : response?.data?.message || "Failed.",
          );

          if (response?.data?.nextActionUserNotFound) {
            setTimeout(() => {
              //navigate(-1); // go back
              if (
                Number(commonContextParams?.roleId) ===
                Number(RoleEnum.TaskOwner)
              ) {
                navigate("/TaskDashboard");
              } else {
                navigate("/RequestDashboard");
              }
            }, 2000);

            return null; // stop further execution if needed
          }

          return null;
        }
      } catch (error: any) {
        message.error("Something went wrong. Please try again.");
        return null;
      }
    },
    ProcessClosureTab: async (
      action: any,
      formValue: any,
      button: any,
      interfaceId: any,
    ) => {
      try {
        const formData = new FormData();

        console.log("Form Value in Closure Tab:", formValue);

        Object.entries(formValue).forEach(([key, value]: any) => {
          if (!Array.isArray(value)) {
            if (value && value.$d instanceof Date) {
              formData.append(key, value.toISOString());
            } else if (value !== undefined && value !== null) {
              formData.append(key, value);
            }
          }
        });
        if (formValue.rId != null)
          formData.append("RId", formValue.rId.toString());

        if (formValue.rId != null)
          formData.append("Id", formValue.rId.toString());

        if (formValue.userId != null)
          formData.append("CreatedBy", formValue.userId.toString());

        if (formValue.roleId != null)
          formData.append("RoleId", formValue.roleId.toString());

        console.log("Form Data fo Closure Tab:", formData);

        //Attachment Processing
        const fileFieldKeys = Object.keys(formValue).filter(
          (key) =>
            Array.isArray(formValue[key]) &&
            formValue[key].some(
              (item: any) => item?.originFileObj || item?.url || item?.path,
            ),
        );

        fileFieldKeys.forEach((fieldKey) => {
          const files = formValue[fieldKey] ?? [];
          const oldAttachments: any[] = [];

          // 1. Create a strict map connecting the UI keys to your exact C# API properties
          const fieldMapping: Record<
            string,
            { newFiles: string; json: string }
          > = {
            RnDManagerClosureDocuments: {
              newFiles: "RnDMangerAttachments",
              json: "RnDMangerAttachmentJson",
            },
            RnDHeadClosureDocuments: {
              newFiles: "RnDHeadAttachments",
              json: "RnDHeadAttachmentJson",
            },
          };

          const targetKeys = fieldMapping[fieldKey];

          // 2. Safety check: If a random key slips in, just skip it so it doesn't crash the app
          if (!targetKeys) return;

          // 3. Loop through files and append
          files.forEach((file: any) => {
            if (file.originFileObj) {
              // Append new file using the mapped key
              formData.append(targetKeys.newFiles, file.originFileObj);
            } else {
              // Keep existing file metadata
              oldAttachments.push({
                id: file.id ?? "",
                name: file.name ?? "",
                path: file.path ?? file.url ?? "",
              });
            }
          });

          // 4. Append the JSON array using the mapped key
          formData.append(targetKeys.json, JSON.stringify(oldAttachments));
        });
        console.log(
          "Form Data with attachments for ProcessRequestDetailTab:",
          formData,
        );

        formData.append("StatusId", requestStatusIdRef.current.toString());

        const response = await API.post(RequestClosure, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (
          response?.data?.message === "OK" &&
          response?.data?.status === ApiStatus.Success
        ) {
          message.success("Saved successfully.");
          // navigate(-1);
          if (
            Number(commonContextParams?.roleId) === Number(RoleEnum.TaskOwner)
          ) {
            navigate("/TaskDashboard");
          } else {
            navigate("/RequestDashboard");
          }
          return response;
        } else {
          message.error(
            response?.data?.errorCode === "DBVALIDATION"
              ? response.data.message
              : response?.data?.message || "Failed.",
          );
          return null;
        }

        // if (response?.data?.status !== 0) {
        //   console.log("Error response from API:", response);
        //   message.error(
        //     response?.data?.errorCode === "DBVALIDATION"
        //       ? response.data.message
        //       : response?.data?.message || "Failed.",
        //   );
        //   return null;
        // }

        // message.success("Saved successfully.");
        // return response.data;
      } catch (error: any) {
        message.error("Something went wrong. Please try again.");
        return null;
      }
    },
  };

  const interfaceFieldActionHandler = {
    HandleRequestTypeChange: async (form: any) => {
      // if(!formRef.current) return;
      if (typeof form.getFieldsValue !== "function") return;
      if (!form) return;

      const rowValues = form?.getFieldsValue();
      console.log("Row Values for on request type change:", rowValues);
      if (rowValues?.RequestType == "-1") {
        console.log("Showing Other Request Type Field");
        //formRef.current?.showField("OtherRequestType");
        formRef.current?.setFieldVisibility([
          {
            fieldName: "OtherRequestType",
            updates: { isFieldVisible: true },
          },
        ]);
        formRef.current?.UpdateFieldMandatoryRule("OtherRequestType", true);
        //formRef.current?.UpdateMultipleFieldMandatoryRule([{fieldName: "OtherRequestType", value: true}]);

        // showFields(["OtherRequestType"]);
      } else {
        //formRef.current?.hideField("OtherRequestType");
        formRef.current?.setFieldVisibility([
          {
            fieldName: "OtherRequestType",
            updates: { isFieldVisible: false },
          },
        ]);
        formRef.current?.UpdateFieldMandatoryRule("OtherRequestType", false);
        //formRef.current?.UpdateMultipleFieldMandatoryRule([{fieldName: "OtherRequestType", value: false}]);
      }
    },
    HandleDecisionChange: async (form: any) => {
      console.log("HandleDecisionChange triggered", form);
      if (typeof form.getFieldsValue !== "function") return;
      if (!form) return;
      presetValues({
        RemarksRDHead: "",
      });

      const rowValues = form?.getFieldsValue();
      console.log("Row Values for on Decision change:", rowValues);

      if (Number(rowValues?.DecisionRDHead) === DecisionEnum.AssignRnDManager) {
        console.log("Showing Field on decision change");

        formRef.current?.setFieldVisibility([
          {
            fieldName: "Priority",
            updates: { isFieldVisible: true },
          },
          {
            fieldName: "ObservationCategory",
            updates: { isFieldVisible: true },
          },
          {
            fieldName: "EstimatedResources",
            updates: { isFieldVisible: true },
          },
          {
            fieldName: "Impact",
            updates: { isFieldVisible: true },
          },
          {
            fieldName: "AssignTo",
            updates: { isFieldVisible: true },
          },
          {
            fieldName: "TargetClosureDate",
            updates: { isFieldVisible: true },
          },
        ]);

        formRef.current?.UpdateFieldMandatoryRule("Priority", true);
        formRef.current?.UpdateFieldMandatoryRule("ObservationCategory", true);
        formRef.current?.UpdateFieldMandatoryRule("EstimatedResources", true);
        formRef.current?.UpdateFieldMandatoryRule("Impact", true);
        formRef.current?.UpdateFieldMandatoryRule("AssignTo", true);
        formRef.current?.UpdateFieldMandatoryRule("TargetClosureDate", true);
      } else {
        formRef.current?.setFieldVisibility([
          {
            fieldName: "Priority",
            updates: { isFieldVisible: false },
          },
          {
            fieldName: "ObservationCategory",
            updates: { isFieldVisible: false },
          },
          {
            fieldName: "EstimatedResources",
            updates: { isFieldVisible: false },
          },
          {
            fieldName: "Impact",
            updates: { isFieldVisible: false },
          },
          {
            fieldName: "AssignTo",
            updates: { isFieldVisible: false },
          },
          {
            fieldName: "TargetClosureDate",
            updates: { isFieldVisible: false },
          },
        ]);
        formRef.current?.UpdateFieldMandatoryRule("Priority", false);
        formRef.current?.UpdateFieldMandatoryRule("ObservationCategory", false);
        formRef.current?.UpdateFieldMandatoryRule("EstimatedResources", false);
        formRef.current?.UpdateFieldMandatoryRule("Impact", false);
        formRef.current?.UpdateFieldMandatoryRule("AssignTo", false);
        formRef.current?.UpdateFieldMandatoryRule("TargetClosureDate", false);
      }
    },
    //Handle Priority change to set target closure date based on priority selected
    HandlePriorityChange: async (form: any) => {
      console.log("HandlePriorityChange triggered", form);
      if (typeof form.getFieldsValue !== "function") return;
      if (!form) return;

      const rowValues = form?.getFieldsValue();
      console.log("Row Values for on Priority change:", rowValues);

      if (rowValues?.Priority) {
        const obj = {
          Priority: rowValues?.Priority,
          CountryLocation: rowValues?.CountryLocation,
        };
        console.log("Requesting target closure date with obj:", obj);
        const res = await API.post(getTargetClosureDateByPriority, obj);

        console.log("Target Closure Date res:", res?.data?.data);
        if (res?.data?.data[0]?.targetClosureDate) {
          formRef.current?.setValue(
            "TargetClosureDate",
            dayjs(res?.data?.data[0]?.targetClosureDate, "YYYY-MM-DD"),
          );
        } else {
          formRef.current?.setValue("TargetClosureDate", null);
        }

        // formRef.current?.setValue(
        //   "TargetClosureDate",
        //   dayjs(res?.data?.data, "YYYY-MM-DD").isValid()
        //     ? dayjs(res?.data?.data, "YYYY-MM-DD")
        //     : null,
        // );
      }
    },
    HandleProductChange: async (form: any) => {
      console.log("HandlePriorityChange triggered", form);
      if (typeof form.getFieldsValue !== "function") return;
      if (!form) return;

      const rowValues = form?.getFieldsValue();
      console.log("Row Values for on Priority change:", rowValues);

      if (rowValues?.Product) {
        const obj = {
          Product: rowValues?.Product,
        };
        console.log("Requesting target closure date with obj:", obj);
        const res = await API.post(getProductCodeByProduct, obj);

        console.log("Product Code", res?.data?.data);
        if (res?.data?.data[0]?.productDescription) {
          formRef.current?.setValue(
            "ProductDescription",
            res?.data?.data[0]?.productDescription,
          );
        } else {
          formRef.current?.setValue("ProductDescription", null);
        }

        // formRef.current?.setValue(
        //   "TargetClosureDate",
        //   dayjs(res?.data?.data, "YYYY-MM-DD").isValid()
        //     ? dayjs(res?.data?.data, "YYYY-MM-DD")
        //     : null,
        // );
      }
    },
  };

  return (
    <>
      <ActionHandlerProvider
        interfaceActionHandler={interfaceActionHandler}
        interfaceFieldActionHandler={interfaceFieldActionHandler}
      >
        <InterfaceComponent
          key={location?.state?.RId ?? "new_request"}
          InterfaceName={"Request Details Interface"}
          DashboardName={""}
          actionType={location?.state?.actionType || "DynamicFormActionCreate"}
          RId={location?.state?.RId ?? null}
          Mode={location?.state?.Mode || "Create"}
          handleCancel={handleCancel1}
          ref={formRef}
          // onFormReady={handleFormReady}
        />
      </ActionHandlerProvider>
    </>
  );
};

export default RequestDetailInterface;
